import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
// import CategoryFilter from './components/CategoryFilter';

import PinMaps from './PinMaps.js';


// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function($) {
    // CategoryFilter();
    
    const mapInstance = new PinMaps();
    let mapEntries = document.querySelector('.map-entries');

    if(mapEntries) {
        mapInstance.init({
            'accessToken' : 'pk.eyJ1Ijoid2l0eXZpcyIsImEiOiJjajl4MGo0OWowczk4MnFtZHVob3I0MTdnIn0.KHhjbfQIuxBcoOsukPTldQ' ,
            'style':  'mapbox://styles/mapbox/streets-v10',
            'center': [mapEntries.dataset.startlng, mapEntries.dataset.startlat],
            'zoom' : mapEntries.dataset.zoom,
            'mapEntries' : mapEntries,
        });
    }
    
    Components.init();
    Plugins.init();
});


